import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { PromoLogLink, PromoLogsFileNames } from 'interfaces/api/promoLogs.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetOneResponse<PromoLogsFileNames> => {
  const { data: response } = await axios.request<PromoLogsFileNames>({
    method: 'GET',
    url: endpoints.promoLogs.getAll(),
  })
  return response
}

const getLink = async (filename: string): GetOneResponse<PromoLogLink> => {
  const { data: response } = await axios.request<PromoLogLink>({
    method: 'GET',
    url: endpoints.promoLogs.getLink(),
    params: { filename },
  })
  return response
}

const download = async (url: string): Promise<Blob> => {
  console.log(url)
  const { data } = await axios.request<File>({
    method: 'GET',
    url,
    responseType: 'blob',
  })
  return new Blob([data])
}

export const promoLogsApi = {
  getAll,
  getLink,
  download,
}
